import type {ReactElement} from "react";
import styled, {DefaultTheme, keyframes} from "styled-components";
const loaderCircle = keyframes`

  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-50px);
  }

  100% {
    transform: translateY(0);
  }

  `;
const loaderCircleSmall = keyframes`

  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-25px);
  }

  100% {
    transform: translateY(0);
  }

  `;

const loaderCircleIcon = keyframes`

0% {
  transform: translateY(0);
}

50% {
  transform: translateY(-10px);
}

100% {
  transform: translateY(0);
}

`;

const LoaderStyled = styled.div<{
  $isSmall?: boolean;
  $color?: keyof DefaultTheme["colors"];
}>`
  width: ${({$isSmall}) => ($isSmall ? "70px" : "140px")};
  height: ${({$isSmall}) => ($isSmall ? "40px" : "80px")};
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 20px auto;
  & .circle {
    width: ${({$isSmall}) => ($isSmall ? "15px" : "30px")};
    height: ${({$isSmall}) => ($isSmall ? "15px" : "30px")};
    border-radius: 15px;
    background-color: ${({$color, theme}) =>
      $color ? theme.colors[$color] : theme.colors.darkPrimary};
    animation: ${({$isSmall}) => ($isSmall ? loaderCircleSmall : loaderCircle)}
      1s ease-in-out infinite;
    &:nth-child(2) {
      animation-delay: 0.25s;
    }
    &:nth-child(3) {
      animation-delay: 0.5s;
    }
  }
  &.icon {
    width: 20px;
    height: 12px;
    margin: 5px auto;
    & .circle {
      width: 5px;
      height: 5px;
      animation: ${loaderCircleIcon} 1s ease-in-out infinite;
      &:nth-child(2) {
        animation-delay: 0.25s;
      }
      &:nth-child(3) {
        animation-delay: 0.5s;
      }
    }
  }
`;

function Loader({
  isSmall = false,
  isIcon = false,
  color = "darkPrimary",
  className = "",
}: {
  isSmall?: boolean;
  isIcon?: boolean;
  color?: keyof DefaultTheme["colors"];

  className?: string;
}): ReactElement {
  return (
    <LoaderStyled
      $color={color}
      className={`loader ${className} ${isIcon ? "icon" : ""}`}
      $isSmall={isSmall}>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
    </LoaderStyled>
  );
}

export default Loader;
